import LoginView from "@/views/Auth/LoginView.vue";
import HomePage from "@/views/Home/HomePage.vue";
import QrReaderPage from "@/views/QrPage/QrReaderPage.vue";
import CertificateView from "@/views/QrPage/CertificateView.vue";

const routes= [
    {
        path: '/',
        redirect: '/reader-home'
    },
    {
        path: '/login',
        name: 'login',
        component: LoginView,
        meta: {
            title: 'Login',
            requiresAuth: false,
            hideNavbar: true
        },
    },
    {
        path: "/reader-home",
        name:"ReaderHome",
        component: HomePage
    },
    {
        path:"/qr-reader",
        name:"QrReader",
        component: QrReaderPage
    },
    {
        path: "/certificate/:id",
        name: "Certificate",
        component: CertificateView
    }
]

export default routes;